// extracted by mini-css-extract-plugin
export var card = "FiveCards-module--card--nj1Gk";
export var cardDescription = "FiveCards-module--cardDescription--DMyTN";
export var cardIcon = "FiveCards-module--cardIcon--lvACQ";
export var cardTitle = "FiveCards-module--cardTitle--hp3UM";
export var cardsGrid = "FiveCards-module--cardsGrid--uPJSw";
export var cardsWrapper = "FiveCards-module--cardsWrapper--CkA-W";
export var iconImage = "FiveCards-module--iconImage--4hQ2T";